import { render, staticRenderFns } from "./MakeDeposit.vue?vue&type=template&id=313a3865&scoped=true&"
import script from "./MakeDeposit.vue?vue&type=script&lang=ts&"
export * from "./MakeDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./MakeDeposit.vue?vue&type=style&index=0&id=313a3865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313a3865",
  null
  
)

export default component.exports